import React, { useState } from 'react'
import './style.scss'
import axios from 'axios'
import {jwtDecode} from 'jwt-decode'
import { api } from '../../utils/api'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import { Images } from '../../utils/Images'
// import 'react-toastify/dist/ReactToastify.css'
import { Link, useNavigate } from 'react-router-dom'
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
//toast.configure({ autoClose: 2000 })

const Login = () => {
    const navigate = useNavigate()
    // const { register, handleSubmit, errors } = useForm()
    const { register, handleSubmit, formState: { errors } } = useForm()

    const [isLogging, setLogging] = useState(false)
    const [showPassword, setShowPassword] = useState(false);
    const token = localStorage.getItem('token')

    // Check Admin Role
    const checkRole = (token) => {
        if (token) {
            const decode = jwtDecode(token)
            const role = decode.role
            if (role === 'super_admin') {
                return navigate(`/dashboard?role=${role}`)
            }
            else{
                return navigate(`/dashboard?role=${role}`)
            }
        } else {
            localStorage.clear()
        }
    }

    if (token) checkRole(token)

    // Submit Form
    const onSubmit = async (data) => {
        try {
            setLogging(true)
            const response = await axios.post(`${api}auth/login`, data)
            if (response.status === 200) {
                localStorage.setItem('token', response.data.token)
                checkRole(response.data.token)
                setLogging(false)
            }
        } catch (error) {
            if (error) {
                setLogging(false)
                toast.warn(error.response.data.message)
            }
        }
    }

    return (
        <div className="auth">
            <div className="container-fluid">
                <div className="row">

                    {/* Content column */}
                    <div className="col-12 col-lg-7 d-none d-lg-block">
                        <div className="content-container">
                            <div className="flex-center flex-column">
                                <div className="logo-container">
                                    <img src={Images.Logo} className="img-fluid" alt="..." />
                                </div>
                                <h2>manage million user</h2>
                                <p>Matrimony admin panel</p>
                                <ul>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image1} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image2} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image3} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image4} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <div className="image-container rounded-circle">
                                            <img src={Images.Image5} className="img-fluid" alt="..." />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Form column */}
                    <div className="col-12 col-lg-5 py-3 credential-container">
                        <div className="flex-center flex-column">
                            <div className="card border-0">
                                <div className="d-lg-none">
                                    <img src={Images.Logo} className="img-fluid" alt="..." />
                                </div>
                                <h3 className="mb-4">Get Started!</h3>
                                
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    {/* E-mail */}
                                    <div className="form-group mb-4">
                                        {errors.email && errors.email.message ? (
                                            <p className="text-danger">{errors.email && errors.email.message}</p>
                                        ) : <p>E-mail</p>
                                        }

                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control shadow-none"
                                            placeholder="Enter e-mail"
                                            {...register("email",{
                                                required: "E-mail is required",
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: "Invalid email address"
                                                }
                                            })}
                                        />
                                    </div>

                                    {/* Password */}
                                    <div className="form-group mb-4">
                                        {errors.password && errors.password.message ? (
                                            <p className="text-danger">{errors.password && errors.password.message}</p>
                                        ) : <p>Password</p>
                                        }
                                        <div className="password-wrapper" style={{ position: 'relative' }}>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            className="form-control shadow-none"
                                            placeholder="Enter password"
                                            {...register("password", {
                                                required: "Please enter password",
                                                minLength: {
                                                    value: 8,
                                                    message: "Minimun length 8 character"
                                                }
                                            })}
                                        />
                                        <button
                                            type="button"
                                            autoComplete="current-password"
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                background: 'transparent',
                                                border: 'none',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {showPassword ? <MdVisibilityOff size={16}/> :  <MdVisibility size={16}/>}
                                        </button></div>

                                        {/* <input
                                            type="password"
                                            name="password"
                                            className="form-control shadow-none"
                                            placeholder="Enter password"
                                            {...register("password",{
                                                required: "Please enter password",
                                                minLength: {
                                                    value: 8,
                                                    message: "Minimun length 8 character"
                                                }
                                            })}
                                        /> */}
                                    </div>


                                    <div className="d-flex justify-content-between">
                                        <div className='p-1'>
                                            <Link to="/reset">Forgot password ?</Link>
                                        </div>
                                        <div className="ml-auto">
                                            <button type="submit" className="btn shadow-none" disabled={isLogging}>
                                                {isLogging ? <span>Logging in...</span> : <span>Login</span>}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;